export interface SupplementaryInvoiceEntity{
    id: number,
    hdrState?: string | null,
    manChargeNo?: string | null,
    opsDate?: Date | null,
    billToCompany?: string | null,
    consortiumCode?: string | null,
    vesselCode?: string | null,
    voyageCode?: string | null,
    handlingTerminal?: string | null,
    vesselName?: string | null,
    serviceCode?: string | null,
    etb?: Date | null,
    etd?: Date | null,
    yourRef?: string | null,
    ourRef?: string | null,
    poNo?: string | null,
    loa?: number | null,
    operatingTml?: string | null,
    soa?: string | null,
    slVesselCode?: string | null,
    slIbVoyageCode?: string | null,
    slObVoyageCode?: string | null,
    manDocNo?: string | null,
    manDraftDocNo?: string | null,
    createdBy?: string | null,
    createdDateTime?: Date | null,
    updatedBy?: string | null,
    updatedDateTime?: Date | null,
    hdrDesc1?: string | null,
    hdrDesc2?: string | null,
    currencyCode?: string | null,
    customerCode?: string | null,
    subject?: string | null,
    chargeDesc?: string | null,
    remarks?: string | null,

    [key: string]: string[] | string | boolean | number | Date | null | undefined
}

export const EMPTY_SUPPLEMENTARY_INVOICE_ENTITY : SupplementaryInvoiceEntity = {
    id: 0,
    hdrState: null,
    manChargeNo: null,
    opsDate: null,
    billToCompany: null,
    consortiumCode: null,
    vesselCode: null,
    voyageCode: null,
    handlingTerminal: null,
    vesselName: null,
    serviceCode: null,
    etb: null,
    etd: null,
    yourRef: null,
    ourRef: null,
    poNo: null,
    loa: null,
    operatingTml: null,
    soa: null,
    slVesselCode: null,
    slIbVoyageCode: null,
    slObVoyageCode: null,
    manDocNo: null,
    manDraftDocNo: null,
    createdBy: null,
    createdDateTime: null,
    updatedBy: null,
    updatedDateTime: null,
    hdrDesc1: null,
    hdrDesc2: null,
    currencyCode: null,
    customerCode: null,
    subject: null,
    chargeDesc: null,
    remarks: null,
}